<template>
 <div class="app">
	<iframe id="iframe" src="mms3D/index.html"></iframe>
	  <NAV :backflag='backflag'></NAV><!-- 导航栏 -->
	  <Lfet></Lfet>
	  <Right></Right>
	  <Bottom></Bottom>
	  <!-- <Devicepop v-if="show" @close='show=false' :message='date'></Devicepop> -->
	  <Menu v-show="menuflag"></Menu>
	 <!-- <div cla></div> -->
 </div>
</template>


<script>
	import NAV from './components/nav/nav.vue';//导航栏
	import Lfet from './components/left/left.vue';//左边盒子
	import Right from './components/right/right.vue';//右边盒子
	import Bottom from './components/bottom/bottom.vue';//底部背景
	// import Devicepop from './components/popup/devicepop.vue';//弹窗
	import Menu from './components/menu/Menu.vue'//菜单
	export default {
	  name: "Home",
	  data(){
	  	return{
			show: false,
			backflag:false,//返回按钮
			menuflag:false,//菜单栏
			date:{
				type:1,
				area:'1F',
				
			}
		}
	  },
	  components: {
		  NAV,//导航栏
		  Lfet,//左边盒子
		  Right,//右边盒子
		  Bottom,//底部背景
		  // Devicepop,//设备弹窗
		  Menu,//菜单栏
	  },
	  methods: {
	 //    popshow(obj){
		// 	this.show=true;
		// 	this.date=obj
		// }
	  },
	  mounted() {
		  window.addEventListener('message',e=>{
			  
				 if(e.data.currView&&e.data.currView!=0){
					 this.backflag=true
					 if(e.data.currView==2){
						 this.menuflag=true
					 }else{
						 this.menuflag=false
					 }
					
				 }else{
					 this.backflag=false
					 this.menuflag=false
				 }
		  })
		  // console.log(this)
		  console.log(this.backflag)
	     // window.popshow=this.popshow
	  }
	};
</script>
<style>
	*{
		margin: 0;
		padding: 0;
	}
	@font-face {
	    font-family: "ruil";
	    src: url("../src/assets/font/锐字锐线怒放黑简1.0.TTF");
	    font-style: normal;
	    font-weight: normal;
	}
	.app{
		width: 100vw;
		height: 100vh;
		/* background: url(assets/img/appbg.png) no-repeat;
		background-size: 100% 100%;
		background-position: center; */
		
	}
	#iframe{
		width: 100%;
		height: 100%;
		border: none;
	}
	.title{
		width: 100%;
		height: 4vh;
		font-weight: 400;
		/* font-family:'ruil'; */
		color: #E2EBF1;
		line-height: 4vh;
		background: url(./assets/img/logo1.png) no-repeat;
		background-position: bottom;
		background-size: 100% auto;
	}
	.title>img{
		height: 60%;
		vertical-align: middle;
		margin-top: -5px;
	}
	.title>span{
		margin-left: 10px;
		font-size:.9vw ;
	}



</style>